const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const NoOrderShotSearchQuery: any = {
    GetNoOrderShotSearch: Backofficebff + '/v1/order/getorderlesswithdrawals',
};
